import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {select} from '@angular-redux/store';
import {ActionsService} from '../../Redux/Actions/actions.service';
import {isNullOrUndefined} from 'util';
import {IeDsUrl, SpecToDesign} from '../../models/SpecToDesign';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {IeDsFile, IeDsFolder, IeDsResource, IFileAction, IRenameResource, iseDsFile} from '../../models/user-info';
import {ApplicationUserInfoActions} from '../../Redux/Actions/application-user-info-actions';
import {edsEnvConfiguration} from '../../../environments/edsEnvConfiguration';
import {MessageDlgComponent} from './message-dlg/message-dlg.component';
import {ApplicationCatalogActions} from '../../Redux/Actions/application-catalog-actions';
import {AnalyticsActions} from '../../Redux/Actions/analytics.actions';
import {RenameResourceDialogComponent} from './user-projects-table/rename-resource-dialog/rename-resource-dialog.component';
import {Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {ConfirmImportDlgComponent} from './confirm-import-dlg/confirm-import-dlg.component';
import {filter, map, mergeMap} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {setWindowTitle} from '../../commonUtil';
import {AuthService} from '../../auth/auth.service';
import {TranslateService} from '@ngx-translate/core';
import * as R from 'ramda';

@Component({
  selector: 'edsng-nav-catalog',
  templateUrl: './nav-catalog.component.html',
  styleUrls: [
    './nav-catalog.component.css',
    './nav-catalog.component.mobile.css',
    './nav-catalog.component.tablet.css'
  ]
})
export class NavCatalogComponent implements OnInit {

  userLogged = false;
  showDashboard = false;
  typeMap = null;

  isAuthenticatedArea = false;

  // @select(["appProjectTypes"]) applicationProjectTypes$;
  // @select(["appProjectTypes", "selected"]) projectTypeSelected$;
  @select(['appUserInfo', 'loadUserData']) loadUserData$: Observable<string>;
  @select(['appProjectTypes', 'appTypeMap']) appTypeMap$;
  @select(['appUserInfo', 'user']) user$;
  @select(['appUserInfo', 'currentUserFolder']) currentUserFolder$;
  @select(['appUserInfo', 'currentExampleFolder']) currentExampleFolder$;
  @ViewChild('inputBtn', {static: false, read: ElementRef}) inputBtn: ElementRef;


  constructor(
    private dialog: MatDialog,
    private act: ActionsService,
    public snack: MatSnackBar,
    public httpAuth: AuthService,
    private router: Router,
    public translate: TranslateService
  ) {
    this.appTypeMap$.subscribe(y => {
      if (y && y.apps) {
        this.typeMap = y;
        this.act.sendAction(ApplicationUserInfoActions.loadUserLogged());
      }
    });
    setWindowTitle(null, translate);
  }

  ngOnInit() {

    // carmelo invio la richiesta di login solo se sono in un ambiente autenticato
    const isDevHost = R.test(/^https:\/\/dev-eds.st.com.*/, window.document.URL) || R.test(/^https:\/\/d125v5a4r4pvyv.cloudfront.net.*/, window.document.URL);
    const isQAHost = R.test(/^https:\/\/qa-eds.st.com.*/, window.document.URL);
    const isProdHost = R.test(/^https:\/\/eds.st.com.*/, window.document.URL);
    this.isAuthenticatedArea = (isDevHost || isQAHost || isProdHost);


    this.act.sendAction(ApplicationCatalogActions.deselectSolution());
    if (this.isAuthenticatedArea) {
      const _userLogged = this.user$.pipe(map(x => !isNullOrUndefined(x)));

      this.loadUserData$.pipe(
        filter(x => x === 'completed'),
        mergeMap(_ => _userLogged)
      ).subscribe(userLogged => {
        if (!userLogged) {
          this.act.sendAction(AnalyticsActions.sendAnalyticsEvent('login', 'engagement', {details: 'login header'}));
          this.act.sendAction(ApplicationUserInfoActions.loginUser());
        }
      });
      _userLogged.subscribe(x => {
        this.userLogged = x;
      });
    } else {
      this.userLogged = true;
    }
  }

  reloadProjectsAndExamples() {
    this.act.sendAction(ApplicationUserInfoActions.loadFileSystems());
  }

  messageLogin() {
    const config = new MatDialogConfig();
    config.disableClose = true;
    const dialogRef = this.dialog.open(MessageDlgComponent, config);
    dialogRef.componentInstance.icon = 'info';
    dialogRef.componentInstance.title = this.translate.instant('COMMON.errors.signIn required title');
    dialogRef.componentInstance.cancelButton = null;
    dialogRef.componentInstance.message = this.translate.instant('COMMON.errors.signIn required import msg');
  }

  // messageRequestLogin() {
  //   const config = new MatDialogConfig();
  //   config.disableClose = true;
  //   const dialogRef = this.dialog.open(MessageDlgComponent, config);
  //   dialogRef.componentInstance.icon = "info";
  //   dialogRef.componentInstance.title = this.translate.instant('COMMON.errors.signIn required title');
  //   dialogRef.componentInstance.cancelButton = null;
  //   dialogRef.componentInstance.message = this.translate.instant('COMMON.errors.signIn required dashboard msg');
  //   dialogRef.afterClosed().subscribe(
  //     _ => this.router.navigate(['/'])
  //   );
  //
  // }

  importClick() {
    this.inputBtn.nativeElement.value = '';
    if (this.userLogged) {
      this.inputBtn.nativeElement.click();
    } else {
      this.messageLogin();
    }
  }

  openDlgImport(name: string, param: IeDsUrl) {
    const config = new MatDialogConfig();
    config.data = {file: name, param: param, userLogged: this.userLogged};
    config.disableClose = true;
    const dialogRef = this.dialog.open(ConfirmImportDlgComponent, config);
  }

  importFile(event) {
    // console.log("File Load", event );
    const input = event.target;
    // console.log("File Load", input.files);
    if (input.files.length > 0) {
      const reader = new FileReader();
      reader.onload = () => {
        // console.log(input.files[0].name, "File content", reader.result)
        SpecToDesign.importUserLocalProject(input.files[0].name, reader.result as string, this.typeMap).subscribe(
          (param) => {
            // this.act.sendAction(AnalyticsActions.sendAnalyticsEvent(
            //   'import_user_file',
            //   'project',
            //   'file name=' + input.files[0].name));
            // window.open(param.base + param.app + "?msg=" + encodeURIComponent(param.msg));
            this.openDlgImport(input.files[0].name, param);
          },
          (err) => {
            const errMsg = 'Import User file [' + input.files[0].name + '] - Error: ' + err;
            this.act.sendAction(AnalyticsActions.sendAnalyticsException(errMsg));
            this.snack.open(errMsg, 'OK', {duration: 3000});
          });
      };
      reader.readAsText(input.files[0]);
    }
  }

  myProjectFileAction(evt: IFileAction) {
    switch (evt.action) {
      case 'open':
        if (evt.file.isFolder) {
          this.act.sendAction(ApplicationUserInfoActions.setCurrentUserFolder(evt.file));
        } else {
          this.openMyProjectFile(evt.file as IeDsFile);
        }
        break;
      case 'export':
        this.exportUserFile(evt.file as IeDsFile);   // available only for files in "my projects"
        break;
      case 'rename':
        this.renameResource(evt.file);
        break;
      case 'delete':
        this.removeSelectedFile(evt.file);
        break;
    }
  }

  // exampleFileAction(evt: IFileAction) {
  //   switch (evt.action) {
  //     case 'open':
  //       if (evt.file.isFolder) {
  //         this.act.sendAction(ApplicationUserInfoActions.setCurrentExampleFolder(evt.file));
  //       } else {
  //         this.openSelectedFile(evt.file as IeDsFile);
  //       }
  //       break;
  //   }
  // }

  renameResource(file: IeDsResource) {
    const configR = new MatDialogConfig();
    configR.disableClose = true;
    configR.data = {file: file, currentFolder: this.currentUserFolder$};
    const dialogRefR = this.dialog.open(RenameResourceDialogComponent, configR);
    dialogRefR.afterClosed().subscribe((x: IRenameResource) => {
      if (!isNullOrUndefined(x)) {
        this.act.sendAction(AnalyticsActions.sendAnalyticsEvent(
          'rename_user_file',
          'project',
          {details: 'id=' + file.id, module: 'home'}));
        const renameUrl = edsEnvConfiguration.renameResource + file.id;
        this.httpAuth.rename(renameUrl, x.newName).subscribe(() => this.act.sendAction(ApplicationUserInfoActions.loadFileSystems()),
          (err) => this.act.sendAction(ApplicationUserInfoActions.loadFileSystems()));
      }
    });

  }

  // private openExampleFile(f: IeDsFile) {
  //   const handleWnd1 = window.open();         // To avoid pop-up blocking window
  //   SpecToDesign.openExampleProject(this.httpAuth, f, this.typeMap).subscribe(
  //     (fa) => {
  //       this.act.sendAction(AnalyticsActions.sendAnalyticsEvent(
  //         'open_example_file',
  //         'project',
  //         {details: 'file=' + f.url}));
  //
  //       handleWnd1.location.href = fa.base + fa.app + "?msg=" + encodeURIComponent(fa.msg);  // To avoid pop-up blocking window
  //       // handleWnd1.location.href = edsEnvConfiguration.login_url + encodeURIComponent(fa.base + fa.app + "?msg=" + fa.msg);  // login
  //
  //       // console.log("openExampleProject ", f);
  //     },
  //     (err) => {
  //       this.act.sendAction(AnalyticsActions.sendAnalyticsException('open example file url=' + f.id));
  //       this.snack.open("Error Open Example file " + f.label + ' :' + err, 'OK', {duration: 3000});
  //       // console.log("Error openExampleProject ", err)
  //     }
  //   );
  // }

  private openMyProjectFile(f: IeDsFile) {
    const handleWnd = window.open();            // To avoid pop-up blocking window
    SpecToDesign.openUserProject(
      this.httpAuth,
      f,
      this.typeMap
    ).subscribe(
      (fa) => {
        this.act.sendAction(AnalyticsActions.sendAnalyticsEvent(
          'open_user_file',
          'project',
          {details: 'id=' + f.id, module: 'home'}));

        handleWnd.location.href = fa.base + fa.app + '?msg=' + encodeURIComponent(fa.msg);    // To avoid pop-up blocking window
        // handleWnd.location.href = edsEnvConfiguration.login_url + encodeURIComponent(fa.base + fa.app + "?msg=" + fa.msg);    // login

        // console.log("openUserProject ", f);
      },
      (err) => {
        handleWnd.close();
        const errMsg = 'Open User file ' + f.label + ' [' + f.id + ']' + ' - Error: ' + err;
        this.act.sendAction(AnalyticsActions.sendAnalyticsException(errMsg));
        this.snack.open(errMsg, 'OK', {duration: 3000});
        // console.log("Error openUserProject ", err);
      });
  }

  private exportUserFile(f: IeDsFile) {
    function download(filename, text) {
      const element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
      element.setAttribute('download', filename);

      element.style.display = 'none';
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    }

    SpecToDesign.getUserProject(
      this.httpAuth,
      f,
    ).subscribe(
      (contentFile) => {
        this.act.sendAction(AnalyticsActions.sendAnalyticsEvent(
          'export_user_file',
          'project',
          {details: 'id=' + f.id, module: 'home'}));
        download(f.label + '.prj', contentFile);

      },
      (err) => {
        const errMsg = 'Export User file ' + f.label + ' [' + f.id + ']' + ' - Error: ' + err;
        this.act.sendAction(AnalyticsActions.sendAnalyticsException(errMsg));
        this.snack.open(errMsg, 'OK', {duration: 3000});
      });
  }

  isRemovable(f: IeDsResource) {
    // if resource is a file or the folder is empty
    return iseDsFile(f)
      || (isNullOrUndefined((f as IeDsFolder).folder) && isNullOrUndefined((f as IeDsFolder).file));
  }

  removeSelectedFile(f: IeDsResource) {
    if (f !== null) {
      // only user file can be removed
      const config = new MatDialogConfig();
      config.disableClose = true;
      const dialogRef = this.dialog.open(MessageDlgComponent, config);
      dialogRef.componentInstance.icon = 'warning';
      dialogRef.componentInstance.title = 'Warning!';
      dialogRef.componentInstance.cancelButton = this.isRemovable(f) ? 'Cancel' : null;
      dialogRef.componentInstance.message = this.isRemovable(f)
        ? ('Are you sure to delete ' + f.label + (iseDsFile(f) ? ' file?' : ' folder?'))
        : ('You can not remove ' + f.label + '. Folder is not empty!');
      dialogRef.componentInstance.onClose.subscribe(result => {
        // console.log("Result", result);
        if (result.toLowerCase() === 'ok' && this.isRemovable(f)) {
          SpecToDesign.deleteUserProject(this.httpAuth, f as IeDsFile).subscribe(
            (x) => {
              this.act.sendAction(AnalyticsActions.sendAnalyticsEvent(
                'remove_user_file',
                'project',
                {details: 'id=' + f.id, module: 'home'}));
              // console.log("deletedUserProject ", f);
              this.act.sendAction(ApplicationUserInfoActions.loadFileSystems());
            });
        }
      });

    }
  }
}
